import React from 'react';
import { Grid, Typography, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LoadingButton from '../utils/LoadingButton';
import MyAccordion from '../utils/MyAccordion';
import CreateShiftFormFields from './CreateShiftFormFields';

interface CreateShiftProps {
  schedDate: string;
  robot: string;
  operator: string;
  rig: string;
  allRobots: any[];
  allOperators: any[];
  allRigs: any[];
  onSchedDateChange: (value: string) => void;
  onRobotChange: (value: string) => void;
  onOperatorChange: (value: string) => void;
  onRigChange: (value: string) => void;
  onCreateShift: () => void;
}

const CreateShift: React.FC<CreateShiftProps> = ({
  schedDate,
  robot,
  operator,
  rig,
  allRobots,
  allOperators,
  allRigs,
  onSchedDateChange,
  onRobotChange,
  onOperatorChange,
  onRigChange,
  onCreateShift,
}) => (
  <Grid container style={{ marginBottom: 2 }} size={12}>
    <MyAccordion style={{ width: '100%' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="body1" style={{ padding: 5 }}>
          Create Shift
        </Typography>
      </AccordionSummary>

      <CreateShiftFormFields
        schedDate={schedDate}
        robot={robot}
        operator={operator}
        rig={rig}
        allRobots={allRobots}
        allOperators={allOperators}
        allRigs={allRigs}
        onSchedDateChange={onSchedDateChange}
        onRobotChange={onRobotChange}
        onOperatorChange={onOperatorChange}
        onRigChange={onRigChange}
      />

      <LoadingButton variant="outlined" color="primary" style={{ marginTop: 20 }} onClick={onCreateShift}>
        Create
      </LoadingButton>
    </MyAccordion>
  </Grid>
);

export default CreateShift;
